export const issuedState = 'Emitida';
export const inCourseState = 'En curso';
export const carBranch = 'Automotor';
